import { render, staticRenderFns } from "./BTabs.vue?vue&type=template&id=a2911a3c&scoped=true"
import script from "./BTabs.vue?vue&type=script&lang=js"
export * from "./BTabs.vue?vue&type=script&lang=js"
import style0 from "./BTabs.vue?vue&type=style&index=0&id=a2911a3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2911a3c",
  null
  
)

export default component.exports